module.exports = __webpack_public_path__ + "media/images/appIcon-b9da355ac7b290d66c5899b042caed29.png";